/**
 * Where the browser says the user is, as [lon, lat] — or a rejection when
 * it can't say (no geolocation, permission refused, timed out).
 */
export function currentLocation(options: PositionOptions = { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }): Promise<[number, number]> {
  return new Promise((resolve, reject) => {
    const geolocation = typeof navigator !== 'undefined' ? navigator.geolocation : undefined;
    if (!geolocation) {
      reject(new Error('Geolocation is not available'));
      return;
    }
    geolocation.getCurrentPosition(
      position => resolve([position.coords.longitude, position.coords.latitude]),
      error => reject(error),
      options
    );
  });
}
